import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { getServerUrl, getApiKey } from '../services/api';

const LicenseContext = createContext({ status: 'active', message: '', isReadOnly: false });

export function LicenseProvider({ children }) {
  const [license, setLicense] = useState({ status: 'active', message: '', isReadOnly: false });

  useEffect(() => {
    async function check() {
      try {
        const url = getServerUrl() || '';
        const { data } = await axios.get(`${url}/api/health`, {
          headers: { 'x-api-key': getApiKey() },
          timeout: 8000,
        });
        const s = data.license?.status || 'active';
        setLicense({
          status: s,
          message: data.license?.message || '',
          clientName: data.license?.clientName || '',
          isReadOnly: s === 'suspended' || s === 'expired',
        });
      } catch {}
    }
    check();
    const t = setInterval(check, 6 * 60 * 60 * 1000);
    return () => clearInterval(t);
  }, []);

  return <LicenseContext.Provider value={license}>{children}</LicenseContext.Provider>;
}

export function useLicense() {
  return useContext(LicenseContext);
}
